import React, { FC } from 'react';

import { t } from 'state/intl/translations';
import { theme } from 'styles/configure-theme';

import { MethodType } from './styled';

interface ICashAppMethod {
  isDisabled?: boolean;
  isRedesign?: boolean;
}

const CashAppMethod: FC<ICashAppMethod> = ({ isDisabled, isRedesign }) => {
  const textProps = isRedesign
    ? { variant: 'headerTwo', fontSize: 'lg', marginTop: '$2' }
    : undefined;

  return (
    <MethodType
      color={isDisabled ? theme.token('text-disabled') : theme.token('text-default')}
      {...textProps}
    >
      {t('cashAppPay')}
    </MethodType>
  );
};

export default CashAppMethod;
